import IconType from "@/types/Icon.type";
import IconDog from "@Icons/ticket/amenities/pets/IconDog";

function IconPetsGroupNotAvailable(props: IconType) {
    return (
        <IconDog
            allowed={false}
            {...props}
        />
    )
}

export default IconPetsGroupNotAvailable